import { useScript } from '#nuxt-scripts/composables/useScript'
import { defineNuxtPlugin } from 'nuxt/app'
import { useScriptGoogleTagManager } from '/workspace/node_modules/@nuxt/scripts/dist/runtime/registry/google-tag-manager.js'
import { useScriptGoogleMaps } from '/workspace/node_modules/@nuxt/scripts/dist/runtime/registry/google-maps.js'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const googleMaps = useScriptGoogleMaps({"scriptOptions":{"trigger":"onNuxtReady"}})
    const googleTagManager = useScriptGoogleTagManager({"id":"GTM-P8CCTG8","scriptOptions":{"trigger":"onNuxtReady"}})
    return { provide: { scripts: { googleMaps, googleTagManager } } }
  }
})